import { AuthService } from 'src/api/safety-system/services';
import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpErrorResponse } from '@angular/common/http';
import { from, Observable, Subject, throwError } from 'rxjs';
import { catchError, filter, finalize, switchMap, take, tap } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { RefreshTokenRequest } from 'src/api/safety-system/models';

@Injectable({
  providedIn: 'root',
})
export class HttpRequestInterceptor implements HttpInterceptor {
  refreshInProgress = false;
  private tokenRefreshSubject: Subject<any> = new Subject<any>();

  constructor(private toastrService: ToastrService, private router: Router, private authService: AuthService) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const spinner = document.querySelector("#loader-container");
    if (spinner) {
      spinner.classList.remove('d-none')
    }
    
    return next.handle(this.addToken(req)).pipe(
      catchError(error => {
        if (error instanceof HttpErrorResponse && error.status === 401) {
          const refreshToken = localStorage.getItem('refreshToken');
          if (refreshToken) {
            // Refresh token logic
            if (!this.refreshInProgress) {
              this.refreshInProgress = true;
              return this.authService.AuthRefreshToken({ refreshToken }).pipe(
                switchMap((response) => {
                  localStorage.setItem('accessToken', response.accessToken);
                  localStorage.setItem('refreshToken', response.refreshToken);
                  this.refreshInProgress = false;
                  location.reload();
                  return next.handle(this.addToken(req));
                }),
                catchError((refreshError) => {
                  this.refreshInProgress = false;
                  this.router.navigate(['/auth/login-page']);
                  return throwError(refreshError);
                })
              );
            } else {
              // Wait for token refresh to complete before retrying the request
              return this.tokenRefreshSubject.pipe(
                filter(result => result !== null),
                take(1),
                switchMap(() => next.handle(this.addToken(req)))
              );
            }
          } else {
            // No refresh token, navigate to login
            this.router.navigate(['/auth/login-page']);
          }
        }
        
        // For non-401 errors, simply pass through
        return from(this.handle(req, next, error));
      }),
      finalize(() => {
        if (spinner) {
          setTimeout(() => {
            spinner.classList.add('d-none');
          });
        }
      })
    );
  }
  
  private addToken(req: HttpRequest<any>): HttpRequest<any> {
    const jwtToken = localStorage.getItem('accessToken');
    if (jwtToken) {
      return req.clone({
        setHeaders: {
          Authorization: `Bearer ${jwtToken}`
        }
      });
    } 
    return req;
  }

  async handle(req: HttpRequest<any>, next: HttpHandler, error) {
    console.log(error)
    let data = { message: '', subject: '' };
    if (this.isObject(error.error)) {
      data = error.error;
    } else {
      try {
        data = JSON.parse(await error.error.text());
      } catch(ex) {
        data = JSON.parse(error.error)
      }
    }
    this.toastrService.error(data.message, data.subject)
    return next.handle(req).toPromise()
  }

   isObject(value: any): boolean {
    return value !== null && typeof value === 'object' && !Array.isArray(value);
  }
}

